/* eslint-disable no-template-curly-in-string */
import { ArrayLocale, BooleanLocale, DateLocale, MixedLocale, NumberLocale, ObjectLocale, StringLocale } from 'yup/lib/locale';
import { Message } from 'yup/lib/types';
import printValue from 'yup/lib/util/printValue';

export const mixed: Required<MixedLocale> = {
  default: '${path} không hợp lệ',
  required: '${path} yêu cầu',
  oneOf: '${path} phải là một trong các giá trị sau: ${values}',
  notOneOf: '${path} không thể là một trong các giá trị sau: ${values}',
  notType: ({ path, type, value, originalValue }) => {
    const isCast = originalValue != null && originalValue !== value;
    let msg =
      `${path} phải thuộc loại \`${type}\`, ` +
      `nhưng giá trị cuối cùng: \`${printValue(value, true)}\`` +
      (isCast
        ? ` (thay đổi từ giá trị \`${printValue(originalValue, true)}\`).`
        : '.');

    if (value === null) {
      msg += `\n Nếu "null" được coi là một giá trị trống, hãy đảm bảo lược đồ sử dụng \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} phải xác định',
};

export const string: Required<StringLocale & { ascii?: Message, emailOrPhone?: Message, zxcvbn?: Message }> = {
  length: '${path} phải đúng ${length} tính cách',
  min: '${path} tối thiểu ${min} tính cách',
  max: '${path} tối đa ${max} tính cách',
  matches: '${path} phải khớp với regex: "${regex}"',
  email: '${path} phải là một email hợp lệ',
  url: '${path} phải là một URL hợp lệ',
  uuid: '${path} phải là một UUID hợp lệ',
  trim: '${path} phải là một ký tự không có khoảng trắng ở cuối',
  lowercase: '${path} phải là chữ thường',
  uppercase: '${path} phải viết hoa',

  ascii: '${path} chứa ký tự không hợp lệ',
  emailOrPhone: '${path} phải là dữ liệu hợp lệ',
  zxcvbn: '${path} tính không đủ mạnh.',
};

export const number: Required<NumberLocale> = {
  min: '${path} phải lớn hơn hoặc bằng ${min}',
  max: '${path} phải nhỏ hơn hoặc bằng ${max}',
  lessThan: '${path} Phải nhỏ hơn ${less}',
  moreThan: '${path} phải nhiều hơn ${more}',
  positive: '${path} phải là số dương',
  negative: '${path} phải là số âm',
  integer: '${path} phải là một số nguyên'
};

export const date: Required<DateLocale> = {
  min: '${path} phải sau ${min}',
  max: '${path} phải trước ${max}',
};

export const boolean: BooleanLocale = {
  isValue: '${path} phải là ${value}',
};

export const object: Required<ObjectLocale> = {
  noUnknown: '${path} có khóa không xác định: ${unknown}',
};

export const array: Required<ArrayLocale & { unique?: Message }> = {
  min: '${path} phải có ít nhất ${min} mục',
  max: '${path} phải nhỏ hơn hoặc bằng ${max} mục',
  length: '${path} phải có ${length} mục',

  unique: '${path} đã tồn tại',
};

export default Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
});
